import styled from 'styled-components';
import { grid, GridProps, variant } from 'styled-system';
import { ThemeUtilities } from '../../../../../theme';
import { StepSize, StepState } from './types';

export const StepTitle = styled.span<{ text: StepState }>`
  position: absolute;
  transition: color 0.2s;
  will-change: color;
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'StepHorizontal', 'text')
    )};
`;

export const StepWrapper = styled.div<GridProps>`
  flex: 1;
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  grid-template-columns: 1fr auto 1fr;

  &:first-child {
    grid-template-columns: 0.5fr auto 1fr;
  }
  &:last-child {
    grid-template-columns: 1fr auto 0.5fr;
  }
  ${grid};
`;

export const StepLine = styled.div<{ color: StepState; lineSize: StepSize }>`
  transition: background-color 0.2s;
  will-change: background-color;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'StepHorizontal', 'color')
    )};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'StepHorizontal', 'lineSize')
    )};
`;

export const StepNumber = styled.div<{ size: 'regular'; color: StepState }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  will-change: background-color;
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'StepHorizontal', 'size')
    )};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'StepHorizontal', 'color')
    )};
`;

export const StepInlineWrapper = styled.div`
  position: relative;
`;

export const TextWrapper = styled.span<{ width: number }>`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: ${({ width }) => width}px;
  text-align: center;
`;
